import { formatDate } from "./formatDate";

export function formatDateRange(startDate, endDate) {
  const startDateYear = startDate.getFullYear();
  const endDateYear = endDate.getFullYear();
  const startDateMonth = startDate.getMonth();
  const endDateMonth = endDate.getMonth();
  const startDateDay = startDate.getDate();
  const endDateDay = endDate.getDate();

  const isSameDay = startDateDay === endDateDay && startDateMonth === endDateMonth && startDateDay === endDateDay;

  if (isSameDay) {
    return formatDate(startDate);
  }

  const now = new Date();
  const isDifferentYear = startDateYear !== endDateYear || now.getFullYear() !== endDateYear;

  return `${formatDate(startDate, isDifferentYear)} - ${formatDate(endDate, isDifferentYear)}`;
}
